import { gql } from '@apollo/client';
// Api
import { CB_COMPANY_PREFERENCES_FIELDS } from 'api/cbCompanyPreferences/queries';

export const EDIT_CB_COMPANY_PREFERENCES = gql`
  mutation EditCbCompanyPreferences($input: CbCompanyPreferencesEditInput!) {
    editCbCompanyPreferences(input: $input) {
      ...CbCompanyPreferencesFields
    }
  }
  ${CB_COMPANY_PREFERENCES_FIELDS}
`;
